import PropTypes from 'prop-types'
import React from 'react'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import { View } from 'components/View'

class Gallery extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    onChangeSelectedIndex: PropTypes.func,
    selectedIndex: PropTypes.number,
    children: PropTypes.arrayOf(PropTypes.element).isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      selectedIndex: props.selectedIndex || 0
    }
  }

  componentDidUpdate (prevProps) {
    if (
      prevProps.name &&
      prevProps.name !== this.props.name
    ) {
      this.setState({
        selectedIndex: 0
      })
    } else if (prevProps.selectedIndex !== this.props.selectedIndex) {
      this.setState({
        selectedIndex: this.props.selectedIndex
      })
    }
  }

  handleClickGalleryItem (index) {
    this.setState({
      selectedIndex: index
    })
    const { onChangeSelectedIndex } = this.props
    if (onChangeSelectedIndex) {
      onChangeSelectedIndex(index)
    }
  }

  renderSmallImages () {
    const children = React.Children
      .toArray(this.props.children)
      .filter(child => child)

    if (children.length === 1) {
      return
    }

    return (
      <View
        style={{
          flexDirection: View.DIRECTION.ROW,
          justifyContent: View.JUSTIFY.CENTER,
          flexWrap: 'wrap'
        }}
      >
        {
          children.map((child, index) => {
            const isSelected = this.state.selectedIndex === index
            return (
              <div
                style={{
                  flex: '1',
                  marginLeft: index ? STYLES_MARGIN.SMALL : null,
                  opacity: isSelected ? '1' : '0.7',
                  cursor: 'pointer'
                }}
                key={index}
              >
                <div
                  onClick={() => this.handleClickGalleryItem(index)}
                >
                  {child}
                </div>
              </div>
            )
          })
        }
      </View>
    )
  }

  renderSelectedImage () {
    const children = React.Children
      .toArray(this.props.children)
      .filter(child => child)

    const child = children[this.state.selectedIndex]
    return (
      <div
        style={{
          opacity: '1',
          marginBottom: '1.33em',
          cursor: 'pointer'
        }}
      >
        {child}
      </div>
    )
  }

  render () {
    return (
      <div className='gallery'>
        {this.renderSelectedImage()}
        {this.renderSmallImages()}
      </div>
    )
  }
}

export default Gallery
